(function () {
    'use strict';

    angular
        .module('app.accountManagement', [
            'angularMoment', // angular-moment, requires moment
            'app.auth'
        ]);
})();